
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"6","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.124.676A.374.374 0 010 .396C0 .29.041.193.124.116a.446.446 0 01.6 0L6 5.043 11.276.116a.446.446 0 01.6 0 .378.378 0 010 .56L6.3 5.884a.446.446 0 01-.6 0L.124.676z","fill":"#C4C4C4"}})])
          )
        }
      }
    